








































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import DataDokterByPoli from "@/services/DataUtility";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/services/RegisterKunjungan";
import { storeDokter } from "@/store/modules/dokter";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class ModalChangeDPJP extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly title!: string;
  @Prop() dtDokter!: object;
  @Prop() dtReg!: object;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  alert: string;
  success: string;

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  save() {
    if (this.readOnly) return;
    this.saving = true;

    RegisterKunjungan.changeDpjp(
      this.dtReg["register"],
      this.dtDokter["c_doc_id"]
    )
      .then(() => {
        this.show = false;
        this.$emit("changed");
      })
      .finally(() => {
        this.saving = false;
      });
  }
}
